
import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import UserListItem from "./users_table";
import { getStoredUserData } from "../../utils/utils";
import NotificationView from "../../components/notification_view";
import { useNavigate } from "react-router-dom";

const Users = (_props:any) => {
const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState("")
  const notifications = []
  const userData = getStoredUserData();
  const showNotifications = () => {
    navigate(`/notifications/${_props.user?.id}`)
}
  return (
    <main className="w-full flex bg-white min-h-full">

      <div className="md:w-2/12 flex flex-col items-start text-center justify-center">
        <Sidebar notificationCount={notifications.length} user={userData} active={2} />                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 f
      </div>

      <div className="md:w-9/12 mx-auto space-y-4 mt-2">
      <div className="w-full flex justify-end items-center"><div className=" space-x-2 w-4/12 flex justify-end mt-0 items-center text-primary ">
                {/* <MdPerson className="hover:text-accent text-2xl"/> */}
                <p className="text-end py-4">{userData?.username}</p>
                <NotificationView count={_props.notificationCount} onNotificationClick={showNotifications} />
            </div></div>
        <div className="flex space-x-2 w-full my-4 items-center justify-between">
          <div className="w-full flex items-center justify-start space-x-2 ">
            <button className="bg-primaryLight text-textDefault hover:bg-accentDark hover:text-white px-2 py-2 w-2/12">New User</button>
            <button className="bg-primaryLight text-textDefault hover:bg-accentDark hover:text-white px-2 py-2 w-2/12">Restore User</button>
            <button className="bg-primaryLight text-textDefault hover:bg-accentDark hover:text-white px-2 py-2 w-2/12">Upload Phone Numbers</button>
          </div>

        </div>
        <UserListItem />
      </div>
    </main>
  );
}

export default Users;